import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  toString22rbkbhdb5cl2 as toString,
  Char__toInt_impl_vasixdnyockrdnmht5 as Char__toInt_impl_vasixd,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { equals2v6cggk171b6e as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { AbstractMutableSetthfi6jds1k2h as AbstractMutableSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/AbstractMutableSet.mjs';
import { AbstractMutableCollections0bg6c40ztuj as AbstractMutableCollection } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/AbstractMutableCollectionJs.mjs';
import {
  MutableEntry12w2i19w0igk5 as MutableEntry,
  Entry2xmjmyutzoq3p as Entry,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  equals2au1ep9vhcato as equals_0,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  fill3hcjvebk42tyx as fill,
  fill2542d4m9l93pn as fill_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function advance($this) {
  $l$loop: while ($this.r4m_1 < $this.t4m_1.y4m_1) {
    var idx = $this.t4m_1.x4m_1[$this.r4m_1];
    if (idx >= 0 && !($this.t4m_1.u4m_1[idx] == null))
      break $l$loop;
    $this.r4m_1 = $this.r4m_1 + 1 | 0;
  }
}
var CaseInsensitiveMap$KeySet$iterator$1Class;
function CaseInsensitiveMap$KeySet$iterator$1() {
  if (CaseInsensitiveMap$KeySet$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.t4m_1 = this$0;
        this.r4m_1 = 0;
        this.s4m_1 = null;
        advance(this);
      }
      q1() {
        return this.r4m_1 < this.t4m_1.y4m_1;
      }
      r1() {
        if (!this.q1())
          throw NoSuchElementException().t6();
        var idx = this.t4m_1.x4m_1[this.r4m_1];
        this.s4m_1 = ensureNotNull(this.t4m_1.u4m_1[idx]);
        this.r4m_1 = this.r4m_1 + 1 | 0;
        advance(this);
        return ensureNotNull(this.s4m_1);
      }
      p6() {
        var tmp0_elvis_lhs = this.s4m_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().o('next() must be called before remove()');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var key = tmp;
        this.t4m_1.c4n(key);
        this.s4m_1 = null;
      }
    }
    initMetadataForClass($);
    CaseInsensitiveMap$KeySet$iterator$1Class = $;
  }
  return CaseInsensitiveMap$KeySet$iterator$1Class;
}
function advance_0($this) {
  $l$loop: while ($this.d4n_1 < $this.f4n_1.y4m_1) {
    var idx = $this.f4n_1.x4m_1[$this.d4n_1];
    if (idx >= 0 && !($this.f4n_1.u4m_1[idx] == null))
      break $l$loop;
    $this.d4n_1 = $this.d4n_1 + 1 | 0;
  }
}
var CaseInsensitiveMap$ValueCollection$iterator$1Class;
function CaseInsensitiveMap$ValueCollection$iterator$1() {
  if (CaseInsensitiveMap$ValueCollection$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.f4n_1 = this$0;
        this.d4n_1 = 0;
        this.e4n_1 = null;
        advance_0(this);
      }
      q1() {
        return this.d4n_1 < this.f4n_1.y4m_1;
      }
      r1() {
        if (!this.q1())
          throw NoSuchElementException().t6();
        var idx = this.f4n_1.x4m_1[this.d4n_1];
        this.e4n_1 = ensureNotNull(this.f4n_1.u4m_1[idx]);
        var tmp = this.f4n_1.v4m_1[idx];
        var result = !(tmp == null) ? tmp : THROW_CCE();
        this.d4n_1 = this.d4n_1 + 1 | 0;
        advance_0(this);
        return result;
      }
      p6() {
        var tmp0_elvis_lhs = this.e4n_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().o('next() must be called before remove()');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var key = tmp;
        this.f4n_1.c4n(key);
        this.e4n_1 = null;
      }
    }
    initMetadataForClass($);
    CaseInsensitiveMap$ValueCollection$iterator$1Class = $;
  }
  return CaseInsensitiveMap$ValueCollection$iterator$1Class;
}
function advance_1($this) {
  $l$loop: while ($this.g4n_1 < $this.i4n_1.y4m_1) {
    var idx = $this.i4n_1.x4m_1[$this.g4n_1];
    if (idx >= 0 && !($this.i4n_1.u4m_1[idx] == null))
      break $l$loop;
    $this.g4n_1 = $this.g4n_1 + 1 | 0;
  }
}
var CaseInsensitiveMap$EntrySet$iterator$1Class;
function CaseInsensitiveMap$EntrySet$iterator$1() {
  if (CaseInsensitiveMap$EntrySet$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.i4n_1 = this$0;
        this.g4n_1 = 0;
        this.h4n_1 = null;
        advance_1(this);
      }
      q1() {
        return this.g4n_1 < this.i4n_1.y4m_1;
      }
      r1() {
        if (!this.q1())
          throw NoSuchElementException().t6();
        var idx = this.i4n_1.x4m_1[this.g4n_1];
        this.h4n_1 = ensureNotNull(this.i4n_1.u4m_1[idx]);
        var tmp = ensureNotNull(this.h4n_1);
        var tmp_0 = this.i4n_1.v4m_1[idx];
        var entry = new (MapEntry())(this.i4n_1, tmp, !(tmp_0 == null) ? tmp_0 : THROW_CCE());
        this.g4n_1 = this.g4n_1 + 1 | 0;
        advance_1(this);
        return entry;
      }
      p6() {
        var tmp0_elvis_lhs = this.h4n_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().o('next() must be called before remove()');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var key = tmp;
        this.i4n_1.c4n(key);
        this.h4n_1 = null;
      }
    }
    initMetadataForClass($);
    CaseInsensitiveMap$EntrySet$iterator$1Class = $;
  }
  return CaseInsensitiveMap$EntrySet$iterator$1Class;
}
function caseInsensitiveHashCode($this, s) {
  var h = 0;
  var inductionVariable = 0;
  var last = s.length;
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = imul(31, h);
      // Inline function 'kotlin.text.lowercaseChar' call
      // Inline function 'kotlin.text.lowercase' call
      var this_0 = charCodeAt(s, i);
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$1 = toString(this_0).toLowerCase();
      // Inline function 'kotlin.code' call
      var this_1 = charCodeAt(tmp$ret$1, 0);
      h = tmp + Char__toInt_impl_vasixd(this_1) | 0;
    }
     while (inductionVariable < last);
  return h;
}
function putWithoutTrackingOrderReturnIndex($this, key, value) {
  var hash = caseInsensitiveHashCode(Companion_getInstance(), key);
  var index = hash & ($this.u4m_1.length - 1 | 0);
  while (true) {
    var existingKey = $this.u4m_1[index];
    if (existingKey == null) {
      $this.u4m_1[index] = key;
      $this.v4m_1[index] = value;
      $this.w4m_1 = $this.w4m_1 + 1 | 0;
      return index;
    }
    if (equals(existingKey, key, true)) {
      $this.v4m_1[index] = value;
      return index;
    }
    index = (index + 1 | 0) & ($this.u4m_1.length - 1 | 0);
  }
}
function findIndex($this, key) {
  if ($this.w4m_1 === 0)
    return -1;
  var hash = caseInsensitiveHashCode(Companion_getInstance(), key);
  var index = hash & ($this.u4m_1.length - 1 | 0);
  while (true) {
    var existingKey = $this.u4m_1[index];
    if (existingKey == null)
      return -1;
    if (equals(existingKey, key, true))
      return index;
    index = (index + 1 | 0) & ($this.u4m_1.length - 1 | 0);
  }
}
function ensureCapacity($this) {
  if (imul($this.w4m_1, 4) >= imul($this.u4m_1.length, 3)) {
    resize($this, imul($this.u4m_1.length, 2));
  }
}
function resize($this, newCapacity) {
  var oldKeys = $this.u4m_1;
  var oldValues = $this.v4m_1;
  var oldInsertionOrder = $this.x4m_1;
  var oldInsertionCount = $this.y4m_1;
  var tmp = $this;
  // Inline function 'kotlin.arrayOfNulls' call
  tmp.u4m_1 = Array(newCapacity);
  var tmp_0 = $this;
  // Inline function 'kotlin.arrayOfNulls' call
  tmp_0.v4m_1 = Array(newCapacity);
  var tmp_1 = $this;
  var tmp_2 = 0;
  var tmp_3 = new Int32Array(newCapacity);
  while (tmp_2 < newCapacity) {
    tmp_3[tmp_2] = -1;
    tmp_2 = tmp_2 + 1 | 0;
  }
  tmp_1.x4m_1 = tmp_3;
  $this.w4m_1 = 0;
  $this.y4m_1 = 0;
  var inductionVariable = 0;
  if (inductionVariable < oldInsertionCount)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var oldIndex = oldInsertionOrder[i];
      if (oldIndex >= 0 && !(oldKeys[oldIndex] == null)) {
        var tmp_4 = ensureNotNull(oldKeys[oldIndex]);
        var tmp_5 = oldValues[oldIndex];
        $this.j4n(tmp_4, !(tmp_5 == null) ? tmp_5 : THROW_CCE());
      }
    }
     while (inductionVariable < oldInsertionCount);
}
function compactInsertionOrder($this) {
  if ($this.y4m_1 === 0)
    return Unit_instance;
  var writeIndex = 0;
  var inductionVariable = 0;
  var last = $this.y4m_1;
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var idx = $this.x4m_1[i];
      if (idx >= 0 && !($this.u4m_1[idx] == null)) {
        var tmp = $this.x4m_1;
        var _unary__edvuaz = writeIndex;
        writeIndex = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = idx;
      }
    }
     while (inductionVariable < last);
  var inductionVariable_0 = writeIndex;
  var last_0 = $this.x4m_1.length;
  if (inductionVariable_0 < last_0)
    do {
      var i_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      $this.x4m_1[i_0] = -1;
    }
     while (inductionVariable_0 < last_0);
  $this.y4m_1 = writeIndex;
}
var KeySetClass;
function KeySet() {
  if (KeySetClass === VOID) {
    class $ extends AbstractMutableSet() {
      static l4n($outer, $box) {
        if ($box === VOID)
          $box = {};
        $box.k4n_1 = $outer;
        return this.b8($box);
      }
      q2() {
        return this.k4n_1.w4m_1;
      }
      m4n(element) {
        throw UnsupportedOperationException().a1('CaseInsensitiveMap.keys does not support add');
      }
      i2(element) {
        return this.m4n((!(element == null) ? typeof element === 'string' : false) ? element : THROW_CCE());
      }
      n4n(element) {
        return this.k4n_1.g2o(element);
      }
      t2(element) {
        if (!(!(element == null) ? typeof element === 'string' : false))
          return false;
        return this.n4n((!(element == null) ? typeof element === 'string' : false) ? element : THROW_CCE());
      }
      p1() {
        return new (CaseInsensitiveMap$KeySet$iterator$1())(this.k4n_1);
      }
    }
    initMetadataForClass($, 'KeySet');
    KeySetClass = $;
  }
  return KeySetClass;
}
var ValueCollectionClass;
function ValueCollection() {
  if (ValueCollectionClass === VOID) {
    class $ extends AbstractMutableCollection() {
      static p4n($outer, $box) {
        if ($box === VOID)
          $box = {};
        $box.o4n_1 = $outer;
        return this.m6($box);
      }
      q2() {
        return this.o4n_1.w4m_1;
      }
      q4n(element) {
        throw UnsupportedOperationException().a1('CaseInsensitiveMap.values does not support add');
      }
      i2(element) {
        return this.q4n(!(element == null) ? element : THROW_CCE());
      }
      p1() {
        return new (CaseInsensitiveMap$ValueCollection$iterator$1())(this.o4n_1);
      }
    }
    initMetadataForClass($, 'ValueCollection');
    ValueCollectionClass = $;
  }
  return ValueCollectionClass;
}
var EntrySetClass;
function EntrySet() {
  if (EntrySetClass === VOID) {
    class $ extends AbstractMutableSet() {
      static s4n($outer, $box) {
        if ($box === VOID)
          $box = {};
        $box.r4n_1 = $outer;
        return this.b8($box);
      }
      q2() {
        return this.r4n_1.w4m_1;
      }
      t4n(element) {
        throw UnsupportedOperationException().a1('CaseInsensitiveMap.entries does not support add');
      }
      i2(element) {
        return this.t4n((!(element == null) ? isInterface(element, MutableEntry()) : false) ? element : THROW_CCE());
      }
      p1() {
        return new (CaseInsensitiveMap$EntrySet$iterator$1())(this.r4n_1);
      }
    }
    initMetadataForClass($, 'EntrySet');
    EntrySetClass = $;
  }
  return EntrySetClass;
}
var MapEntryClass;
function MapEntry() {
  if (MapEntryClass === VOID) {
    class $ {
      constructor($outer, key, _value) {
        this.w4n_1 = $outer;
        this.u4n_1 = key;
        this.v4n_1 = _value;
      }
      m3() {
        return this.u4n_1;
      }
      n3() {
        return this.v4n_1;
      }
      equals(other) {
        if (!(!(other == null) ? isInterface(other, Entry()) : false))
          return false;
        return equals_0(this.u4n_1, other.m3()) && equals_0(this.n3(), other.n3());
      }
      hashCode() {
        return getStringHashCode(this.u4n_1) ^ hashCode(this.n3());
      }
      toString() {
        return this.u4n_1 + '=' + toString_0(this.n3());
      }
    }
    initMetadataForClass($, 'MapEntry', VOID, VOID, [MutableEntry()]);
    MapEntryClass = $;
  }
  return MapEntryClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.x4n_1 = 8;
        var tmp = this;
        // Inline function 'kotlin.emptyArray' call
        tmp.y4n_1 = [];
        var tmp_0 = this;
        // Inline function 'kotlin.emptyArray' call
        tmp_0.z4n_1 = [];
        this.a4o_1 = new Int32Array(0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CaseInsensitiveMapClass;
function CaseInsensitiveMap() {
  if (CaseInsensitiveMapClass === VOID) {
    class $ {
      constructor() {
        Companion_getInstance();
        this.u4m_1 = Companion_getInstance().y4n_1;
        this.v4m_1 = Companion_getInstance().z4n_1;
        this.w4m_1 = 0;
        this.x4m_1 = Companion_getInstance().a4o_1;
        this.y4m_1 = 0;
        this.z4m_1 = null;
        this.a4n_1 = null;
        this.b4n_1 = null;
      }
      q2() {
        return this.w4m_1;
      }
      g2o(key) {
        return findIndex(this, key) >= 0;
      }
      s4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return false;
        return this.g2o((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      h2o(key) {
        var index = findIndex(this, key);
        return index >= 0 ? this.v4m_1[index] : null;
      }
      u4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return null;
        return this.h2o((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      n1() {
        return this.w4m_1 === 0;
      }
      a5() {
        if (this.w4m_1 > 0) {
          fill(this.u4m_1, null);
          fill(this.v4m_1, null);
          fill_0(this.x4m_1, -1);
          this.w4m_1 = 0;
          this.y4m_1 = 0;
        }
      }
      j4n(key, value) {
        if (this.u4m_1 === Companion_getInstance().y4n_1) {
          var tmp = this;
          // Inline function 'kotlin.arrayOfNulls' call
          tmp.u4m_1 = Array(8);
          var tmp_0 = this;
          // Inline function 'kotlin.arrayOfNulls' call
          tmp_0.v4m_1 = Array(8);
          var tmp_1 = this;
          var tmp_2 = 0;
          var tmp_3 = new Int32Array(8);
          while (tmp_2 < 8) {
            tmp_3[tmp_2] = -1;
            tmp_2 = tmp_2 + 1 | 0;
          }
          tmp_1.x4m_1 = tmp_3;
        }
        var hash = caseInsensitiveHashCode(Companion_getInstance(), key);
        var index = hash & (this.u4m_1.length - 1 | 0);
        while (true) {
          var existingKey = this.u4m_1[index];
          if (existingKey == null) {
            ensureCapacity(this);
            index = hash & (this.u4m_1.length - 1 | 0);
            while (!(this.u4m_1[index] == null)) {
              index = (index + 1 | 0) & (this.u4m_1.length - 1 | 0);
            }
            if (this.y4m_1 === this.x4m_1.length) {
              compactInsertionOrder(this);
            }
            this.u4m_1[index] = key;
            this.v4m_1[index] = value;
            var tmp_4 = this.x4m_1;
            var _unary__edvuaz = this.y4m_1;
            this.y4m_1 = _unary__edvuaz + 1 | 0;
            tmp_4[_unary__edvuaz] = index;
            this.w4m_1 = this.w4m_1 + 1 | 0;
            return null;
          }
          if (equals(existingKey, key, true)) {
            var oldValue = this.v4m_1[index];
            this.v4m_1[index] = value;
            return oldValue;
          }
          index = (index + 1 | 0) & (this.u4m_1.length - 1 | 0);
        }
      }
      x4(key, value) {
        var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
        return this.j4n(tmp, !(value == null) ? value : THROW_CCE());
      }
      b4o(from) {
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = from.l3().p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          // Inline function 'kotlin.collections.component1' call
          var key = element.m3();
          // Inline function 'kotlin.collections.component2' call
          var value = element.n3();
          this.j4n(key, value);
        }
      }
      z4(from) {
        return this.b4o(from);
      }
      c4n(key) {
        var index = findIndex(this, key);
        if (index < 0)
          return null;
        var oldValue = this.v4m_1[index];
        var inductionVariable = 0;
        var last = this.y4m_1;
        if (inductionVariable < last)
          $l$loop: do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.x4m_1[i] === index) {
              this.x4m_1[i] = -1;
              break $l$loop;
            }
          }
           while (inductionVariable < last);
        this.u4m_1[index] = null;
        this.v4m_1[index] = null;
        this.w4m_1 = this.w4m_1 - 1 | 0;
        var nextIndex = (index + 1 | 0) & (this.u4m_1.length - 1 | 0);
        while (!(this.u4m_1[nextIndex] == null)) {
          var rehashKey = ensureNotNull(this.u4m_1[nextIndex]);
          var rehashValue = this.v4m_1[nextIndex];
          var oldRehashIndex = nextIndex;
          this.u4m_1[nextIndex] = null;
          this.v4m_1[nextIndex] = null;
          this.w4m_1 = this.w4m_1 - 1 | 0;
          var newIndex = putWithoutTrackingOrderReturnIndex(this, rehashKey, !(rehashValue == null) ? rehashValue : THROW_CCE());
          var inductionVariable_0 = 0;
          var last_0 = this.y4m_1;
          if (inductionVariable_0 < last_0)
            $l$loop_0: do {
              var i_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              if (this.x4m_1[i_0] === oldRehashIndex) {
                this.x4m_1[i_0] = newIndex;
                break $l$loop_0;
              }
            }
             while (inductionVariable_0 < last_0);
          nextIndex = (nextIndex + 1 | 0) & (this.u4m_1.length - 1 | 0);
        }
        return oldValue;
      }
      y4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return null;
        return this.c4n((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      v4() {
        var tmp0_elvis_lhs = this.z4m_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = KeySet().l4n(this);
          this.z4m_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      l3() {
        var tmp0_elvis_lhs = this.a4n_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = EntrySet().s4n(this);
          this.a4n_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      w4() {
        var tmp0_elvis_lhs = this.b4n_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = ValueCollection().p4n(this);
          this.b4n_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      equals(other) {
        if (other === this)
          return true;
        if (!(other instanceof CaseInsensitiveMap()))
          return false;
        if (!(other.q2() === this.w4m_1))
          return false;
        var inductionVariable = 0;
        var last = this.u4m_1.length - 1 | 0;
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var k = this.u4m_1[i];
            if (!(k == null)) {
              var v = this.v4m_1[i];
              if (!equals_0(other.h2o(k), v))
                return false;
            }
          }
           while (inductionVariable <= last);
        return true;
      }
      hashCode() {
        var result = 0;
        var inductionVariable = 0;
        var last = this.u4m_1.length - 1 | 0;
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var k = this.u4m_1[i];
            if (!(k == null)) {
              var tmp = result;
              var tmp_0 = caseInsensitiveHashCode(Companion_getInstance(), k);
              var tmp0_safe_receiver = this.v4m_1[i];
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
              result = tmp + (tmp_0 ^ (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs)) | 0;
            }
          }
           while (inductionVariable <= last);
        return result;
      }
    }
    initMetadataForClass($, 'CaseInsensitiveMap', CaseInsensitiveMap, VOID, [KtMutableMap()]);
    CaseInsensitiveMapClass = $;
  }
  return CaseInsensitiveMapClass;
}
//region block: exports
export {
  CaseInsensitiveMap as CaseInsensitiveMap3bv985x2xrppt,
};
//endregion

//# sourceMappingURL=CaseInsensitiveMap.mjs.map
